<div class="sso-options">
  @for (ssoClientOption of ssoClientOptions; track ssoClientOption.SsoClientId) {
    <div class="sso-option-group">
      <a class="sso-option"
         href="/auth/{{ ssoClientOption.ChallengeUrl }}">
        <div class="sso-info">
          <img [src]="ssoClientOption.LogoUrl"
               alt="{{ ssoClientOption.DisplayName }} logo"
               class="sso-logo">

          <div class="sso-text">
            Sign in with {{ ssoClientOption.DisplayName }}
            <small>{{ ssoClientOption.Description }}</small>
          </div>
        </div>
      </a>

      @if (ssoClientOption.SupportLink) {
        <a class="support-link"
           target="blank"
           [href]="ssoClientOption.SupportLink">
          {{ ssoClientOption.DisplayName }} Help
          <mat-icon>open_in_new</mat-icon>
        </a>
      } @else {
        <!-- To keep the options evenly spaced -->
        <div class="support-link">&nbsp;</div>
      }
    </div>
  } @empty {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <div class="error-text">
        No SSO options available. Use the Back button to log in with your EZLynx credentials.
      </div>
    </div>
  }
</div>

<div class="button">
  <button mat-flat-button
          class="back-button"
          (click)="back()">Back</button>
</div>